import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { FileSaverService } from 'ngx-filesaver';
import { EcitationReportService } from 'src/services/ecitation-report.service';


@Component({
    selector: 'app-ecitation-delivery-summary-report',
    templateUrl: './ecitation-delivery-summary-report.component.html',
    styleUrls: ['./ecitation-delivery-summary-report.component.css'],
    standalone: false
})
export class EcitationDeliverySummaryReportComponent implements OnInit {

  userData: any[] = []
  constructor(private ecitationReportService: EcitationReportService, private fileSaverService: FileSaverService) {

  }
  ngOnInit(): void {
    this.onChangeYear({ target: { value: 'ALL' } })

  }
  onChangeYear(event: any) {
    console.log(event.target.value)
    this.ecitationReportService.getdeliverySummaryReport(event.target.value).subscribe((res) => {
      this.userData = Array.isArray(res) ? res : [];
    })
  }
  excelExport() {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
    const headers = ['Destination System','Queued','Delivered','Failed','Rejected']
    const worksheet = XLSX.utils.json_to_sheet([],{header:headers})
    XLSX.utils.sheet_add_json(worksheet , this.userData , {origin:'A2',skipHeader:true})
    const workbook = {
      Sheets: {
        'Delivery-Summary-Report': worksheet
      },
      SheetNames: ['Delivery-Summary-Report']
    }
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blobData = new Blob([excelBuffer], { type: EXCEL_TYPE })
    this.fileSaverService.save(blobData, "Delivery-Summary-Report")
  }

  onSort(event: any, name: any, isSortable: boolean = true) {
    if (isSortable) {
      let spanEle = event.target.querySelector('i') != null ? event.target.querySelector('i') : event.target,
        classList = spanEle.classList;
      let sortDir = 1;
      if (classList.contains('fa-sort') || classList.contains('fa-sort-up')) {
        classList.remove('fa-sort')
        classList.remove('fa-sort-up')
        classList.add('fa-sort-down')
        sortDir = -1
      } else {
        classList.add('fa-sort-up')
        classList.remove('fa-sort-down')
      }
      this.sortBy(name, sortDir)
    }
  }
  sortBy(name: string, order: number) {
    this.userData.sort((a: any, b: any) => {
      a = isNaN(a[name]) ? String(a[name]).toLowerCase() : Number(a[name]);
      b = isNaN(b[name]) ? String(b[name]).toLowerCase() : Number(b[name]);
      if (order == 1) {
        return a < b ? -1 : (a > b ? 1 : 0)
      } else {
        return b < a ? -1 : (b > a ? 1 : 0)
      }
    })
  }


}
